import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ListboxModule } from 'primeng/listbox';
import { ChangeOrderNotificationsComponent } from './changeorder.notifications.component';

@NgModule({
    imports: [
        CheckboxModule,
        CommonModule,
        SelectModule,
        FormsModule,
        ToggleSwitchModule,
        ListboxModule,
        ChangeOrderNotificationsComponent
    ],
    exports: [ChangeOrderNotificationsComponent]
})
export class ChangeOrderNotificationsModule { }
